import * as mod from 'lodash';
if (true) {
  module.exports = mod.default;
} else {
  module.exports = mod;
}